// Стартует перевод Kraken -> Nium
import {TUUID} from '@/types';
import {TKraken} from './types';
import {Nium, TGroup, Verto} from '../types';
import {getKrakenPayout} from './mock';
import CancelablePromise from 'mn-utils/CancelablePromise';
import {apiRequestAdmin} from '../../../ws';
import {getGroup} from '../mock';
import faker from '@faker-js/faker';
import {GROUP_TYPE_NIUM, GROUP_TYPE_VERTO} from '../constants';
import {
  ENDPOINT_ADMIN_PO_KRAKEN_START,
  ENDPOINT_ADMIN_PO_KRAKEN_UPDATE,
  ENDPOINT_ADMIN_PO_KRAKEN_REFRESH
} from "../../../../constants/api";

export function apiAdminPayoutStartKrakenNium(params: {group_id: TUUID}): Promise<TKraken> {
  const url = ENDPOINT_ADMIN_PO_KRAKEN_START;
  if (process.env.MOCK) {
    const response = getKrakenPayout();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

// Добавляет транзакцию Kraken -> Nium проведённую вне процессинга
type TKrakenManualUpdateParams = {group_id: TUUID, payment_info: TKraken}
export function apiAdminPayoutKrakenManualUpdate(params: TKrakenManualUpdateParams): Promise<TGroup<Verto | Nium>> {
  const url = ENDPOINT_ADMIN_PO_KRAKEN_UPDATE;
  if (process.env.MOCK) {
    const group = (faker.helpers as any).arrayElement([GROUP_TYPE_VERTO, GROUP_TYPE_NIUM]);
    const response = getGroup(group);
    console.info({url, params, response, group});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}

// Обновляет статус перевода Kraken -> Nium
export function apiAdminPayoutKrakenManualRefreshTransaction(params: {group_id: TUUID}): Promise<TKraken> {
  const url = ENDPOINT_ADMIN_PO_KRAKEN_REFRESH;
  if (process.env.MOCK) {
    const response = getKrakenPayout();
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }
  return apiRequestAdmin(url, params);
}
